// M4 workstream C (world): the single import surface for the small `// M4-C:` hunks in shared core files
// (production.js, m3/offshore.js, m3/opsactions.js, m3/megaprojects.js, m3/leaserounds.js, m3/nationalize.js,
// m3/regimes.js, m2/politics.js, wellcontrol.js, events.js, core/actions.js). Every hook is neutral before 2000.
import { spotPrice } from '../../economy/market.js';
import { m4On } from './worldCore.js';
import { sanctionPriceMult, capitalControlPriceMult, capitalControlsOnSale } from './worldPolitics.js';
import { heavySaleBlock, heavyPriceMult, heavyOnSale } from './worldOilSands.js';

export { worldDrillGate, worldPreAssign, worldCharterBlock } from './worldDeep.js';
export { m4BopFailMult, m4IncidentMult } from './worldRegime.js';
export { m4RegionBlock, m4WellNat, M4_NAT_REGIONS, leaseRoundM3Shape } from './worldPolitics.js';
export { m4MegaOpenDay, m4MegaName } from './worldMega.js';
export { applyM4WorldNewsEffect } from './worldNews.js';

// production.netbackParts: quality multiplier (sanctions discount / price cap, capital-control duty & cap, syncrude).
export function worldQuality(state, fieldId, quality) {
  if (!m4On(state)) return quality;
  const price = Math.max(0, spotPrice(state)) * quality;
  let m = sanctionPriceMult(state, fieldId, price);
  m *= capitalControlPriceMult(state, fieldId, price * m);
  m *= heavyPriceMult(state, fieldId);
  return quality * m;
}
// production.shipAndSell: bitumen / extra-heavy crude with no diluent or upgrader cannot be shipped.
export const worldSaleBlocked = (state, fieldId) => (m4On(state) ? heavySaleBlock(state, fieldId) : null);
// production.shipAndSell, after the sale: diluent cost, capital controls (trapped pesos).
export function worldOnSale(state, fieldId, bbl, gross) {
  if (!m4On(state) || !(bbl > 0)) return;
  heavyOnSale(state, fieldId, bbl, gross);
  capitalControlsOnSale(state, fieldId, gross);
}
